module.exports = __webpack_public_path__ + "static/img/vippay-logo.9ed683b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/vippay-logo.svg
// module id = t+Ot
// module chunks = 1